import { ENDPOINTS } from '@/api/endpoints'
import type { CurrentUserResponse } from '@/api/types/user'

import { useEndpoint } from './useEndpoint'

type UseUserResponse = {
  data: CurrentUserResponse
  isLoading: boolean
  error: { code: number; message: string } | null
  isUninitialized: boolean
}
export const useUser = (): UseUserResponse =>
  useEndpoint({
    method: 'GET',
    url: ENDPOINTS.USER(),
    body: {},
  }) as UseUserResponse

export const useUserExpiry = () => {
  const { error: userError, isLoading, isUninitialized } = useUser()
  const isUserExpired =
    userError?.code === 401 ||
    userError?.message === 'Expired JWT Token' ||
    userError?.message === 'Invalid JWT Token'
  return { isExpiryLoading: isLoading || isUninitialized, isUserExpired }
}
